<!-- 登录 -->
<template>
  <div class="login">
    <div class="main">
      <img src="../assets/loginImg.png" alt="" />
      <div class="main_right">
        <div class="title"><i></i><span>登录</span></div>
        <div class="form">
          <li>
            <input
              v-model="form.account"
              type="text"
              placeholder="请输入手机号"
            />
            <p>手机号</p>
            <!-- <span v-if="error.account">请输入正确的电子邮箱或密码</span> -->
            <span v-if="error.account">{{ error.account }}</span>
          </li>
          <li>
            <input
              v-model="form.password"
              type="password"
              placeholder="请输入密码"
            />
            <p>密码</p>
            <span v-if="error.password">{{ error.password }}</span>
          </li>
          <li>
            <input
              v-model="form.captcha"
              type="text"
              placeholder="请输入右侧校验码"
            />
            <p>校验码</p>
            <img :src="captchaImg" @click="refreshCaptcha" alt="验证码" />
            <span v-if="error.captcha">{{ error.captcha }}</span>
          </li>
        </div>
        <button @click="handleLogin">登录</button>
        <li><router-link to="/register">去注册</router-link></li>
        <p>Copyright © 课程思政研究院 |&nbsp;黑ICP备2020006330号</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getCaptcha, getLogin } from "../api/userApi";

export default {
  data() {
    return {
      form: {
        account: "",
        password: "",
        captcha: "",
      },
      captchaKey: "",
      captchaImg: "",
      error: {
        account: "",
        password: "",
        captcha: "",
      },
    };
  },
  created() {
    const token = localStorage.getItem("token");
    console.log(token, "token");

    if (token) {
      this.$router.push("/");
      return;
    }
    this.refreshCaptcha();
  },
  methods: {
    // 刷新验证码
    async refreshCaptcha() {
      try {
        const res = await getCaptcha();
        if (res.code === 1) {
          this.captchaKey = res.data.key;
          this.captchaImg = res.data.img;
        } else {
          this.$message.error("获取验证码失败");
        }
      } catch (error) {
        this.$message.error("获取验证码出错");
      }
    },

    // 验证表单
    validateForm() {
      let isValid = true;
      this.error = {
        account: "",
        password: "",
        captcha: "",
      };

      if (!this.form.account) {
        this.error.account = "请输入手机号";
        isValid = false;
      } else if (!/^1[3-9]\d{9}$/.test(this.form.account)) {
        this.error.account = "请输入正确的手机号";
        isValid = false;
      }

      if (!this.form.password) {
        this.error.password = "请输入密码";
        isValid = false;
      } else if (this.form.password.length < 6) {
        this.error.password = "密码长度不能少于6位";
        isValid = false;
      }

      if (!this.form.captcha) {
        this.error.captcha = "请输入验证码";
        isValid = false;
      } else if (this.form.captcha.length !== 4) {
        this.error.captcha = "验证码应为4位";
        isValid = false;
      }

      return isValid;
    },

    // 处理登录
    async handleLogin() {
      if (!this.validateForm()) return;

      try {
        const { account, password, captcha } = this.form;
        const res = await getLogin(account, password, this.captchaKey, captcha);

        if (res.code === 1) {
          this.$message.success("登录成功");
          const token = res.data?.token;
          console.log(token, "token");

          localStorage.setItem("token", token);
          this.$store.commit("setLoginStatus", true);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg || "登录失败");
          this.refreshCaptcha(); // 登录失败刷新验证码
        }
      } catch (error) {
        this.$message.error("登录出错");
        this.refreshCaptcha();
      }
    },
  },
};
</script>

<style scoped lang="less">
li {
  list-style: none;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.login {
  background: url(../assets/loginBg.png) no-repeat center/cover;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .main {
    width: 1200px;
    height: 700px;
    background: #ffffff;
    box-shadow: 0px 3px 32px 0px rgba(52, 96, 161, 0.1098);
    border-radius: 16px 16px 16px 16px;
    display: flex;
    .main_right {
      padding: 76px 110px 42px 80px;
      box-sizing: border-box;
      .title {
        display: flex;
        align-items: center;
        i {
          width: 6px;
          height: 32px;
          background: #175dc2;
          display: block;
        }
        span {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 28px;
          color: #06213d;
          margin-left: 20px;
        }
      }
      .form {
        margin: 68px 0 66px 0;
        li {
          margin-bottom: 40px;
          position: relative;
          width: 400px;
          height: 48px;
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid #adb8d3;
          display: flex;
          justify-content: space-between;
          //   align-items: center;
          span {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #ea2a35;
            margin: 16px;
            line-height: 12px;
          }
          img {
            width: 101px;
            height: 36px;
            margin: 6px 12px 6px 0;
            cursor: pointer;
          }
          input {
            outline: none;
            border: none;
            width: 200px;
            height: 35px;
            margin: 9px 0;
            padding-left: 32px;
          }
          input::placeholder {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: rgba(133, 136, 143, 0.3);
            padding: 16px 0;
          }
          input::focus {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 20px;
            color: rgba(133, 136, 143, 1);
            padding: 16px 0;
          }

          p {
            position: absolute;
            top: -11px;
            left: 20px;
            width: 72px;
            height: 22px;
            background: #ffffff;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #85888f;
          }
        }
        li:last-child {
          margin-bottom: 0;
        }
      }
      button {
        width: 400px;
        height: 48px;
        border: none;
        outline: none;
        cursor: pointer;
        background: #175dc2;
        box-shadow: 0px 3px 12px 0px rgba(153, 156, 163, 0.302);
        border-radius: 24px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 20px;
        color: #ffffff;
        letter-spacing: 3px;
        margin-bottom: 25px;
      }
      li {
        margin-bottom: 78px;
        a {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #121212;
        }
      }
      p {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #858a95;
      }
    }
  }
}
</style>
